const React = require('react')
const IconCancel = require('shared/assets/svg/cancel.svg')
const IconCancelBlack = require('shared/assets/svg/cancel_black.svg')

module.exports = {
  close: <IconCancel width="12px" height="12px" />,
  closeBlack: <IconCancelBlack width="12px" height="12px" />,
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/modal/index.js